import { ApiErrorSchema, UpdateLocaleResponseSchema, type Locale } from '@ah/contracts';

/** Thin fetch wrapper for the ADR-015 locale preference. Same shape as the mobile/therapist-portal clients'. */
export class AccountApi {
  constructor(private readonly baseUrl: string) {}

  /** PATCH /api/v1/account/locale (ADR-015 §3) — persists the UI-language preference server-side so it follows the admin across devices. */
  async updateLocale(accessToken: string, preferredLocale: Locale): Promise<Locale> {
    const res = await fetch(`${this.baseUrl}/api/v1/account/locale`, {
      method: 'PATCH',
      headers: { 'content-type': 'application/json', Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ preferredLocale }),
    });
    if (!res.ok) throw await this.toError(res);
    return UpdateLocaleResponseSchema.parse(await res.json()).preferredLocale;
  }

  private async toError(res: Response): Promise<Error> {
    try {
      const payload = ApiErrorSchema.parse(await res.json());
      return new AccountApiError(payload.error.code, payload.error.message, res.status);
    } catch {
      return new AccountApiError('INTERNAL_ERROR', res.statusText, res.status);
    }
  }
}

export class AccountApiError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly status: number,
  ) {
    super(message);
    this.name = 'AccountApiError';
  }
}
